import http from '@/plugins/axios';

export async function create_rate(payload) {
    const response = await http.post(`customer/review/create`, payload);
    return response.data;

}
